import { render } from "./Rastenberg.vue?vue&type=template&id=0106df19"
import script from "./Rastenberg.vue?vue&type=script&lang=js"
export * from "./Rastenberg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__